import React, { FC } from "react";

import { Link, IconType, Icon } from "~/ui";

type Props = {
  to: string;
  title: string;
  RightIcon?: IconType;
  className?: string;
  ariaLabel?: string;
};

export const LinkTitleItem: FC<Props> = ({
  to,
  title,
  RightIcon = "ioChevronForward",
  className = "",
  ariaLabel,
}) => {
  return (
    <Link
      to={to}
      aria-label={ariaLabel ?? title}
      className={[
        "group block w-full rounded-2xl border border-secondary-400/70 bg-white p-4",
        "transition-all duration-150 ease-in-out",
        "hover:-translate-y-0.5 hover:border-primary-400",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400",
        className,
      ].join(" ")}
    >
      <div className="flex items-center justify-between">
        <h3 className="truncate text-base font-semibold text-secondary-600">
          {title}
        </h3>

        <Icon
          icon={RightIcon}
          size="1rem"
          className="transition-transform duration-150 ease-in-out group-hover:translate-x-0.5 text-secondary-400 group-hover:text-primary-800"
        />
      </div>
    </Link>
  );
};
